import { EsignatureType } from '~/enums/EsignatureType';

export type EsignatureIntegrationType = 'personal' | 'company';

type EsignatureIntegrationIdentityMap = {
  [K in EsignatureIntegrationType]: K;
};

export const IntegrationMap: EsignatureIntegrationIdentityMap = {
  personal: 'personal',
  company: 'company',
};

export interface ESignatureIntegration {
  id: string;
  providerName: EsignatureType;
  integrationType: EsignatureIntegrationType;
  authenticatedUserCount: number;
  isActive: boolean;
  isCompanyAccountLoggedIn: boolean;
  error?: { message: string };
}

export interface ESignatureIntegrationData extends ESignatureIntegration {
  disabled?: boolean;
}

export type EsignatureIntegrationWithMetadata = ESignatureIntegrationData & {
  name?: string;
  provider?: EsignatureType;
};

export interface ESignatureIntegrationCardProps {
  esignatureIntegration?: ESignatureIntegrationData;
  activeEsignatureIntegrationCount?: number;
  isRefetching?: boolean;
  onRefetch?: (data?: unknown) => void;
}

export const MODAL_KEYS = {
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE: 'manage',
  REVOKE: 'revoke',
} as const;

export type IntegrationModalKey = (typeof MODAL_KEYS)[keyof typeof MODAL_KEYS];

export interface IntegrationAttributes {
  type: 'COMPANY' | 'PERSONAL';
  vendor: string;
  authenticated_user_count: number;
  has_active_token: boolean;
}

export interface Integration {
  type: 'integrations';
  id: string;
  attributes: IntegrationAttributes;
}

export type ESigIntegrationsResponse = Integration[];

export interface Vendor {
  type: 'vendors';
  id: string;
  attributes: {
    name: string;
  };
}
export type ESigVendorsResponse = Vendor[];

export interface ESignatureIntegrationUser {
  type: 'auth-identity';
  id: string;
  attributes: {
    internal_user_id: number;
    external_user_email: string;
  };
}

export type ESigGetIntegrationUsersResponse = ESignatureIntegrationUser[];
export type ESignatureIntegrationUsers = ESignatureIntegrationUser[];
